module.exports = __webpack_public_path__ + "static/media/people2.9e331351.jpeg";